import { defineStore } from 'pinia'

interface GlobalDialogData {
  title: string
  content: string
}

export const useGlobalDialogStore = defineStore('global-dialog', () => {
  const _isDialogShow = ref(false)

  const _globalDialogData = ref<GlobalDialogData | null>(null)

  const globalDialogData = computed(() => {
    return _globalDialogData.value
  })

  const isDialogShow = computed(() => {
    return _isDialogShow.value
  })

  /** 顯示 API 錯誤訊息 */
  const openGlobalDialog = (data: GlobalDialogData) => {
    _globalDialogData.value = data
    _isDialogShow.value = true
  }

  const closeGlobalDialog = () => {
    _globalDialogData.value = null
    _isDialogShow.value = false
  }

  return {
    globalDialogData,
    isDialogShow,
    openGlobalDialog,
    closeGlobalDialog
  }
})
